import React, { useState } from "react";
import useCopyDataset from "hooks/useCopyDataset";
import { Tooltip } from "react-tooltip";
import { formatDatasetValue } from "utils/value-format-utils";
import { InstantDoubleValue } from "../../../api/model/dataset/InstantDoubleValue";
import { DatasetDataInfo } from "../../../models/dataset-models";
import DatasetTooltipText, {
  MappedValue,
} from "../../basic/dataset-tooltip-text/DatasetTooltipText";
import "./DatasetButtonComponent.scss";

const DOUBLE_CLICK_THRESHOLD = 300;

type DatasetButtonProps = {
  id: string;
  value: string | undefined;
  selected: boolean;
  dataset: DatasetDataInfo;
  data: InstantDoubleValue | null | undefined;
  time: Date;
  style?: React.CSSProperties;
  compactMode?: boolean;
  setIdentifiers(id: string, ctrlPressed: boolean, doubleClick: boolean): void;
};

const DatasetButtonComponent = (props: DatasetButtonProps) => {

  const [isHovered, setIsHovered] = useState(false);
  const [clickTime, setClickTime] = useState(Date.now());
  useCopyDataset(isHovered, props.dataset.title, props.dataset.identifier);

  const onButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const now = Date.now();

    if (e.ctrlKey && now - clickTime < DOUBLE_CLICK_THRESHOLD) {
      props.setIdentifiers(props.dataset.identifier as string, true, true);
    } else if (e.ctrlKey && now - clickTime >= DOUBLE_CLICK_THRESHOLD) {
      props.setIdentifiers(props.dataset.identifier as string, true, false);
    } else if (!e.ctrlKey && now - clickTime < DOUBLE_CLICK_THRESHOLD) {
      props.setIdentifiers(props.dataset.identifier as string, false, true);
    }
    setClickTime(now);
  };

  return (
    <>
      <Tooltip anchorSelect={`#${props.id}`} style={{ zIndex: 99999 }}>
        <DatasetTooltipText data={props.data} time={props.time} dataset={props.dataset} />
      </Tooltip>
      <div
        className={`button-clickable${props.selected ? " selected-label" : ""}${props.compactMode ? " compact-button-wrapper" : " button-wrapper"}`}
        id={props.id ?? ""}
        onClick={onButtonClick}
        onPointerEnter={() => setIsHovered(true)}
        onPointerLeave={() => setIsHovered(false)}
        style={props.style}
      >
        <i>
          {props.dataset.stringValueMapper ? (
            <MappedValue mapValue={props.data?.value} mapperId={props.dataset.stringValueMapper} />
          ) : (
            <>
              {formatDatasetValue(props.dataset, props.data)}
              {props.data?.value && ` ${props.dataset?.unit}`}
            </>
          )}
        </i>
      </div>
    </>
  );
};

export default DatasetButtonComponent;
